import { FC } from 'react';
import Box from '@mui/material/Box';
import { Text } from '@concepta/react-material-ui';
import ErrorText from 'app/components/ErrorText';
import { BRAINTREE_DROPIN_CONTAINER_ID } from 'app/hooks/useBraintreePayment';
import type { BraintreePaymentStatus } from 'app/hooks/useBraintreePayment';
import { isMobile } from 'utils/isMobile';

interface Props {
  status: BraintreePaymentStatus;
}

const Braintree: FC<Props> = ({ status }) => {
  const show = status === 'creating' || status === 'ready';

  return (
    <Box>
      {!isMobile && (
        <Text
          fontSize={36}
          fontWeight={700}
          color="primary.darker"
          align="left"
          mt={4}
        >
          Please select the payment mode
        </Text>
      )}

      <Box
        mt={isMobile ? 4 : 0}
        id={BRAINTREE_DROPIN_CONTAINER_ID}
        sx={{ display: show ? 'block' : 'none' }}
      />

      {status === 'error' && (
        <ErrorText>
          The payment form is unavailable. Please refresh and try again.
        </ErrorText>
      )}
    </Box>
  );
};

export default Braintree;
